<!-- 电子围栏管理 -->
<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @row-save="rowSave"
      @row-update="rowUpdate"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      :beforeOpen="beforeOpen"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="fencePointsForm" slot-scope="{ type }">
        <div class="fence-editor">
          <div class="fence-editor__toolbar">
            <el-button
              type="primary"
              size="small"
              icon="el-icon-location-outline"
              :disabled="type === 'view'"
              @click="completeFence"
            >
              闭合围栏
            </el-button>
            <el-button
              size="small"
              icon="el-icon-refresh-left"
              :disabled="type === 'view'"
              @click="clearFence"
            >
              清空重画
            </el-button>
            <span class="fence-editor__summary">{{ fenceSummary }}</span>
          </div>
          <TiandiMap
            class="fence-editor__map"
            height="420px"
            :polygon-points="fencePath"
            :auto-fit="fencePath.length > 0"
            :initial-markers="[]"
            :selectable="type !== 'view'"
            :show-toolbar="false"
            :overlay-image-url="fenceOverlayImageUrl"
            :overlay-config="fenceOverlayConfig"
            overlay-storage-key="tiandi-map-electronic-fence-guochu-overlay"
            :persist-overlay-config="false"
            @map-click="handleMapClick"
          ></TiandiMap>
        </div>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, getInspectionRoleList } from "./api";
import { getSearchTimeConfig } from "@/basic-common/util/common";
import TiandiMap from "@/components/tiandi-map/index.vue";

const DEFAULT_CENTER = [105.2593, 37.6294];
const FENCE_OVERLAY_IMAGE_URL = `${process.env.BASE_URL || "/"}cdn/tiandi/img/guochu-factory-overlay-transparent.png?v=20260724-inner-white`;
const FENCE_OVERLAY_CONFIG = {
  centerLng: 105.26089,
  centerLat: 37.63015,
  width: 0.0332,
  height: 0.00961,
  opacity: 1,
  nudgeStep: 0.00005,
};

export default {
  name: "electronic-fence-manage",
  mixins: [crudMixins],
  components: {
    TiandiMap,
  },
  data() {
    return {
      form: {},
      apiConfig: { getList, add, update, remove, getDetail },
      fenceOverlayImageUrl: FENCE_OVERLAY_IMAGE_URL,
      fenceOverlayConfig: { ...FENCE_OVERLAY_CONFIG },
      fencePath: [],
      openType: "",
      option: {
        ...this.$store.state.publicOption,
        rowKey: "id",
        dialogWidth: 980,
        column: [
          {
            label: "围栏名称",
            prop: "fenceName",
            search: true,
            maxlength: 100,
            rules: [
              { required: true, message: "请输入围栏名称", trigger: "blur" },
            ],
          },
          {
            label: "围栏编码",
            prop: "fenceCode",
            search: true,
            maxlength: 64,
          },
          {
            label: "巡检人角色",
            prop: "roleNames",
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "巡检人角色",
            prop: "roleIdList",
            type: "select",
            multiple: true,
            hide: true,
            span: 24,
            dicData: [],
            props: {
              label: "roleName",
              value: "roleId",
            },
            rules: [
              { required: true, message: "请选择巡检人角色", trigger: "change" },
            ],
          },
          {
            label: "围栏范围",
            prop: "fencePoints",
            hide: true,
            span: 24,
            formslot: true,
            slotName: "fencePointsForm",
            rules: [
              { required: true, message: "请在地图上绘制围栏范围", trigger: "change" },
            ],
          },
          {
            label: "中心经度",
            prop: "centerLng",
            hide: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "中心纬度",
            prop: "centerLat",
            hide: true,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
            search: true,
            value: 1,
            dicData: [
              { label: "启用", value: 1 },
              { label: "禁用", value: 0 },
            ],
            rules: [
              { required: true, message: "请选择状态", trigger: "change" },
            ],
          },
          {
            label: "备注",
            prop: "remark",
            type: "textarea",
            span: 24,
            minRows: 3,
            maxRows: 5,
            maxlength: 500,
            overHidden: true,
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: 150,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...getSearchTimeConfig("", { type: "datetimerange" }),
            paramsKey: ["startTime", "endTime"],
          },
        ],
      },
    };
  },
  computed: {
    fenceSummary() {
      if (!this.fencePath.length) {
        return "点击地图添加围栏顶点，至少3个点";
      }
      return `已选择 ${this.fencePath.length} 个顶点`;
    },
  },
  created() {
    this.loadInspectionRoles();
  },
  methods: {
    loadInspectionRoles() {
      getInspectionRoleList().then((res) => {
        const list = res.data.data || res.data || [];
        const roleColumn = this.option.column.find((item) => item.prop === "roleIdList");
        if (roleColumn) {
          roleColumn.dicData = list.map((item) => ({
            ...item,
            roleId: String(item.roleId),
          }));
        }
      });
    },
    beforeOpen(done, type) {
      this.openType = type;
      if (["edit", "view"].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then((res) => {
          this.form = this.formatForm(res.data.data || res.data || {});
          done();
          this.$nextTick(() => this.initMap());
        });
      } else {
        this.form = this.formatForm({ status: 1 });
        done();
        this.$nextTick(() => this.initMap());
      }
    },
    formatForm(row = {}) {
      const result = { ...row };
      result.roleIdList = Array.isArray(result.roleIdList)
        ? result.roleIdList.map((item) => String(item)).filter(Boolean)
        : [];
      return result;
    },
    normalizeForm(row) {
      const result = { ...row };
      result.roleIdList = Array.isArray(result.roleIdList)
        ? result.roleIdList.filter(Boolean)
        : [];
      return result;
    },
    rowSave(row, done, loading) {
      this.apiConfig.add(this.normalizeForm(row)).then(() => {
        this.selectionClear();
        this.onLoad(this.page);
        this.$message({ type: "success", message: "操作成功" });
        done();
      }, () => {
        loading();
      });
    },
    rowUpdate(row, index, done, loading) {
      this.apiConfig.update(this.normalizeForm(row)).then(() => {
        this.selectionClear();
        this.onLoad(this.page);
        this.$message({ type: "success", message: "操作成功" });
        done();
      }, () => {
        loading();
      });
    },
    rowDel(row) {
      this.$confirm("确定删除选中信息？").then(() => {
        this.loading = true;
        this.apiConfig.remove(row.id).then(() => {
          this.selectionClear();
          this.onLoad(this.page);
          this.$message({ type: "success", message: "操作成功" });
        }).catch(() => {
          this.loading = false;
        });
      });
    },
    initMap() {
      this.fencePath = this.parseFencePoints(this.form.fencePoints);
    },
    handleMapClick(event) {
      const point = event.lnglat || [event.longitude, event.latitude];
      this.fencePath.push(point);
      this.syncFenceForm();
    },
    completeFence() {
      if (this.fencePath.length < 3) {
        this.$message.warning("电子围栏至少需要3个坐标点");
        return;
      }
      this.syncFenceForm();
    },
    clearFence() {
      this.fencePath = [];
      this.$set(this.form, "fencePoints", "");
      this.$set(this.form, "centerLng", "");
      this.$set(this.form, "centerLat", "");
    },
    syncFenceForm() {
      this.$set(this.form, "fencePoints", JSON.stringify(this.fencePath));
      const center = this.getCenter(this.fencePath);
      this.$set(this.form, "centerLng", center[0]);
      this.$set(this.form, "centerLat", center[1]);
    },
    parseFencePoints(fencePoints) {
      if (!fencePoints) {
        return [];
      }
      try {
        const points = JSON.parse(fencePoints);
        return Array.isArray(points)
          ? points.filter((item) => Array.isArray(item) && item.length >= 2)
          : [];
      } catch (e) {
        return [];
      }
    },
    getCenter(points) {
      if (!points.length) {
        return DEFAULT_CENTER;
      }
      const total = points.reduce((sum, point) => {
        sum[0] += Number(point[0]);
        sum[1] += Number(point[1]);
        return sum;
      }, [0, 0]);
      return [
        Number((total[0] / points.length).toFixed(12)),
        Number((total[1] / points.length).toFixed(12)),
      ];
    },
  },
};
</script>

<style scoped lang="scss">
.fence-editor {
  width: 100%;
}

.fence-editor__toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.fence-editor__summary {
  color: #606266;
  font-size: 13px;
}

.fence-editor__map {
  width: 100%;
  height: 420px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;
}
</style>
